export default {
      id: "calendar-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#calendar",
      toString: function () {
        return this.url;
      }
    }